import { Check, Star } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { PRICING as DATA } from "@/data/urban";
import { PRICING as TID } from "@/constants/testIds";

export const Pricing = () => {
  return (
    <section id="pricing" className="relative py-24 md:py-36 bg-canvas">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><div className="overline text-ink">Packages</div></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-[1.05]">
              Transparent pricing for every scale.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-ink-soft">Indicative starting prices. Every quote is itemised — no hidden costs, ever.</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {DATA.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.07}>
              <div
                data-testid={TID.card(p.name.toLowerCase())}
                className={`relative h-full rounded-3xl border p-7 flex flex-col ${
                  p.highlight ? "bg-ink text-canvas border-ink shadow-2xl lg:-translate-y-4" : "bg-surface text-ink border-hairline"
                }`}
              >
                {p.highlight && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 bg-black text-white text-[11px] font-bold px-3 py-1 rounded-full">
                    <Star className="h-3 w-3 fill-[#1A1A1A]" /> Most Popular
                  </span>
                )}
                <div className={`overline ${p.highlight ? "text-white" : "text-ink"}`}>{p.name}</div>
                <div className="mt-3 flex items-end gap-2">
                  <span className="font-heading text-4xl font-extrabold">{p.price}</span>
                  <span className={`text-sm mb-1 ${p.highlight ? "text-canvas/60" : "text-ink-soft"}`}>{p.unit}</span>
                </div>
                <div className={`text-sm ${p.highlight ? "text-canvas/60" : "text-ink-soft"}`}>{p.note}</div>

                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm">
                      <Check className={`h-4 w-4 mt-0.5 shrink-0 ${p.highlight ? "text-white" : "text-ink"}`} />
                      <span className={p.highlight ? "text-canvas/90" : "text-ink"}>{f}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  data-testid={TID.cta(p.name.toLowerCase())}
                  className={`mt-7 inline-flex items-center justify-center py-3 rounded-full font-semibold transition-colors ${
                    p.highlight ? "bg-black text-white hover:bg-ink" : "bg-ink text-canvas hover:bg-ink hover:text-white"
                  }`}
                >
                  {p.name === "Custom" ? "Talk to us" : "Choose " + p.name}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
